/**
 * Validation Utilities
 * Value checking and error extraction helpers
 */

/**
 * Check if a value is valid (not null and not undefined)
 * @param value - Value to check
 * @returns True if value is valid
 */
export function isValidValue<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
